import axios from 'axios';
import { Message } from 'element-ui';

const definition = {
    state: () => ({
        countries: [],
        cities: [],
        enums: [],
        organizationCategories: [],
        eventCategories: [],
        allTimeZones: [],
    }),
    actions: {
        async getPolicy(store, payload) {
            var res = await axios.post('/Definition/GetPolicyByType', payload)
            if(res.data.alert.hasError){
                Message.error(res.data.alert.message);
            }
            return res;
        },
        async getEventCategories(context) {
            var res = await axios.post('/Definition/ListEventCategories', { take: 1000, skip: 0 })
            if (!res.data.alert.hasError) {
                context.commit('setEventCategoriesOrganization', res.data.data.items)
            }
            return res;
        },
        async getOrganizationCategories(context) {
            var res = await axios.post('/Definition/ListOrganizationCategories', { take: 1000, skip: 0 })
            if (!res.data.alert.hasError) {
                context.commit('setOrganizationCategories', res.data.data.items)
            }
            return res;
        },
        async getAllTimeZones(context) {
            var res = await axios.post('/Definition/ListAllTimeZones', { take: 1000, skip: 0 })
            if (!res.data.alert.hasError) {
                context.commit('setAllTimeZones', res.data.data.items)
            }
        },
        async getEnums(context) {
            var res = await axios.get('/Definition/ListEnums');
            if (!res.data.alert.hasError) {
                context.commit('setEnums', res.data.data.items);
            } else {
                Message.error(res.data.alert.message);
            }
        },
        async getCountries(context) {
            var res = await axios.post('Definition/ListCountries', { take: 1000, skip: 0 });

            if (!res.data.alert.hasError) {
                context.commit('setCountries', res.data.data.items);
            } else {
                Message.error(res.data.alert.message);
            }
        },

        async getCities(context, payload) {
            var res = await axios.post('Definition/ListCities', { countryId: payload, skip: 0, take: 1000 });
            if (!res.data.alert.hasError) {
                context.commit('setCities', res.data.data.items);
            } else {
                Message.error(res.data.alert.message);
            }
        },
    },
    mutations: {
        setOrganizationCategories(state,payload){
            Object.freeze(payload);
            state.organizationCategories = payload;
        },
        setEnums(state, payload) {
            Object.freeze(payload);
            state.enums = payload;
        },
        setCountries(state, payload) {
            Object.freeze(payload);
            state.countries = payload;
        },
        setCities(state, payload) {
            Object.freeze(payload);
            state.cities = payload;
        },
        setEventCategoriesOrganization(state, payload) {
            Object.freeze(payload);
            state.eventCategories = payload;
        },
        setAllTimeZones(state, payload) {
            Object.freeze(payload);
            state.allTimeZones = payload;
        }
    },
    getters: {
        getOrganizationCategories: (state) => state.organizationCategories,
        getEventCategories: (state) => state.eventCategories,
        getEnums: (state) => state.enums,
        getCountries: (state) => state.countries,
        getCities: (state) => state.cities,
        getAllTimeZones: (state) => state.allTimeZones,
    },
};

export default definition;


// WEBPACK FOOTER //
// ./src/store/definition.js